import React from "react"

import classNames from "classnames"

import { TabBarContext } from "../context/TabBarContext"
import { useTabBarViewModel } from "../model/useTabBarViewModel"
import { useTabListKeyboardNavigation } from "../model/useTabListKeyboardNavigation"
import type { TabBarRootProps } from "./TabBarRoot"

export const TabBarBaseRoot = React.memo(
  ({ children, ...props }: Omit<TabBarRootProps, "enableSort" | "onSort">) => {
    const { context, containerProps } = useTabBarViewModel(props)
    const handleKeyDown = useTabListKeyboardNavigation()
    return (
      <TabBarContext.Provider value={context}>
        <div
          {...containerProps}
          className={classNames("tab-bar", "nav", "nav-tabs", props.className)}
          role="tablist"
          tabIndex={-1}
          onKeyDown={handleKeyDown}
        >
          {children}
        </div>
      </TabBarContext.Provider>
    )
  }
)

TabBarBaseRoot.displayName = "TabBar.BaseRoot"
